<div >
    <mat-dialog-content>
        <div class="header">
            
                @if(modalName == 'rating'){
                
                    @if(!saveTimeOnly){
                        <div class="title-success">
                            <img src="/assets/icons/badge-success.svg"  alt="success badge"/>
                           Thank You for Your Rating and Time Saved Details
                        </div>
                    }@else{
                        <div class="title-success">
                            <img src="/assets/icons/badge-success.svg" alt="success badge" />
                        Thank You for Your Time Saved Details
                        </div>
                    }
                }@else{
                <div class="title">
                        <img src="/assets/icons/Badge.svg"  *ngIf=" actionType === 'add'"  alt="add badge"/>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" *ngIf=" actionType === 'save'">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 24.5C18.6274 24.5 24 19.1274 24 12.5C24 5.87258 18.6274 0.5 12 0.5C5.37258 0.5 0 5.87258 0 12.5C0 19.1274 5.37258 24.5 12 24.5Z" fill="#0F69AF"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9995 8.84318C13.0094 8.84318 13.828 8.0245 13.828 7.01461C13.828 6.00471 13.0094 5.18604 11.9995 5.18604C10.9896 5.18604 10.1709 6.00471 10.1709 7.01461C10.1709 8.0245 10.9896 8.84318 11.9995 8.84318ZM10.7402 18.8317C11.1197 19.2112 11.6438 19.4009 12.3124 19.4009H13.5865C13.8395 19.4009 13.966 19.2925 13.966 19.0756V12.8136C13.966 12.145 13.7763 11.6209 13.3968 11.2414C13.0173 10.8618 12.4932 10.6721 11.8245 10.6721H10.5504C10.2974 10.6721 10.1709 10.7805 10.1709 10.9974V17.2594C10.1709 17.9281 10.3607 18.4521 10.7402 18.8317Z" fill="white"/>
                          </svg>
                         Saved successfully
                </div>
                }
            
            <div class="title" *ngIf=" actionType === 'remove'">
                <img src="/assets/icons/Badgegreen-check.svg"  alt="green badge check"/>Removed from My Favourites
            </div>
            <div>
                <img class="close" src="/assets/icons/Close-new.svg" (click)="onConfirmClick()" alt="close"/>
            </div>
        </div>
        @if(modalName == 'rating') {
            @if(!saveTimeOnly){  
                <div class="message">
                    Your rating and time saved details have been saved successfully.
                </div>
            } @else {
                <div class="message"> Your time saved details have been saved successfully.</div>
            }
        } @else {
            <div class="message"> '{{message}}' prompt saved successfully</div>
        }
        
    </mat-dialog-content>
</div>
